export const FEDOPS_SERVICES_LIST_WIDGET_EDITOR =
  'bookings-services-widget-editor';

export const FEDOPS_MAIN_PAGE_WIDGET_EDITOR =
  'bookings-main-page-widget-editor';

export const SENTRY_BOOKINGS_WIDGET_DSN =
  'https://487dbfbf210c492cac29cec41461385a@sentry.wixpress.com/173';
